<template>
    <div class="mx-auto pt-120 px-30 lg:(j-p-0 j-w-1180 j-pt-120)">
        <h2 class="benefit-title" v-html="t('member_index.membership_benefits.title')"></h2>
        <ul class="grid grid-cols-2 gap-20 lg:(grid-cols-3 j-gap-20)">
            <li
                v-for="{ icon, desc, } in benefits"
                :class="[ icon === '' ? 'benefit-item-col' : 'benefit-item' ]"
            >
                <div v-if="icon === ''" class="benefit-banner">
                    <img class="lazyload hidden lg:block w-full h-auto object-cover" data-src="https://cdn.shopifycdn.net/s/files/1/0550/0524/9633/files/PC_487bdc24-faa9-47cb-b4c2-2091be0ef441.png?v=1685097191">
                    <img class="lazyload block lg:hidden w-full h-auto object-cover" data-src="https://cdn.shopifycdn.net/s/files/1/0550/0524/9633/files/MB_9e39ada3-2b0b-4423-ac31-b7a55e32f94f.png?v=1685097191">
                </div>
                <div v-else class="benefit-icon">
                    <img :src="icon"> 
                </div>
                <p :class="[ icon === '' ? 'benefit-text-col' : 'benefit-text' ]" v-html="desc"></p>
            </li>
        </ul>
    </div>
</template>
<script setup>
import { cookie, getAssetsFile, } from '@u/common'
import { useRegisterInterestsInfo } from '@/hooks/useRegisterBenefit.js'
import { onMounted } from 'vue';

const { t } = useI18n()

// 格式化金额
const CR = cookie.get("_jk_cr") || localStorage.getItem('JACKERY_ID_CR') || 'US'

const list = ref([
    {
        display: () => true,
        icon: '',
        desc: t('member_index.membership_benefits.banner_text'),
    },
    {
        display: () => true,
        icon: getAssetsFile('index', 'PC-benefits1.svg'),
        desc: t('member_index.membership_benefits.coupon_benefit', { 'num': 0}),
    },
    {
        display: () => CR !== 'AU',
        icon: getAssetsFile('index', 'PC-benefits2.svg'),
        desc: t('member_index.membership_benefits.giftcard_benefit', { 'num': 0}),
    },
    {
        display: () => true,
        icon: getAssetsFile('index', 'PC-benefits3.svg'),
        desc: t('member_index.membership_benefits.product_benefit'),
    },
    {
        display: () => true,
        icon: getAssetsFile('index', 'PC-benefits4.svg'),
        desc: t('member_index.membership_benefits.gift_benefit'),
    },
])
const benefits = list.value.filter(it => it.display())

onMounted(async () => {
    const { firstRegister, largeOrder, } = await useRegisterInterestsInfo()
    list.value[1].desc = t('member_index.membership_benefits.coupon_benefit', { 'num': firstRegister})
    list.value[2].desc = t('member_index.membership_benefits.giftcard_benefit', { 'num': largeOrder})
})
</script>
<style scoped>
.benefit-title {
  @apply
    w-full text-left text-52 leading-64 Poppins-SemiBold font-semibold text-sub p-40
    lg:(text-center j-text-48 j-leading-48 j-p-0 j-mb-48)
}

.benefit-banner {
  @apply
    w-full min-h-220 rounded-20 lg:(j-w-380 j-min-h-600 j-rounded-16) overflow-hidden
}
.benefit-item-col {
  @apply
    col-span-2 lg:col-span-1 lg:row-span-2 w-full h-220 rounded-20 text-28 lg:j-text-24
    lg:j-leading-32 lg:j-w-380 lg:j-h-600 lg:j-rounded-16 lg:bg-transparent relative
}
.benefit-text-col {
  @apply
    benefit-text w-80% !mt-0 !text-white absolute left-40 bottom-1/2 translate-y-1/2
    lg:j-left-30 lg:j-top-200 lg:translate-y-0 lg:j-text-24 lg:j-leading-32 Poppins-SemiBold font-semibold
}

.benefit-item {
  @apply
    w-335 min-h-350 rounded-20 p-40 bg-white
    lg:(j-w-380 j-min-h-290 j-rounded-16 j-p-30 flex items-start justify-between flex-col)
}
.benefit-icon {
  @apply
    w-120 h-120 bg-white rounded-6 lg:(j-w-100 j-h-100 j-rounded-6) overflow-hidden
}
.benefit-text {
  @apply
    w-full mt-40 text-28 leading-36 Poppins-SemiBold font-semibold text-black lg:(j-mt-0 j-text-24 j-leading-32 j-min-h-64)
}
</style>
